<template>
  <a-tabs v-model:activeKey="activeKey" @tabClick="tabClick">
    <a-tab-pane :key="-1" tab="全部"> </a-tab-pane>
    <a-tab-pane
      v-for="(item, index) in configList"
      :key="item.dbName"
      :tab="item.appName"
      :disabled="loading"
    >
    </a-tab-pane>
  </a-tabs>
  <XATable :columns="columns" :dataSource="tableData" :loading="loading">
    <template #pageView="{ record }">
      <!-- {{ scope.pageView }} -->
    </template>
    <template #income="{ record }"> $ {{ record.income }} </template>
    <template #action="{ record }">
      <a @click="confirmDetail(record)" v-if="record.day !== '汇总'">详情</a>
    </template>
  </XATable>

  <XDialog
    :visible="detailVisible"
    :title="adsTitle"
    xWidth="100%"
    @cancel="detailVisible = false"
  >
    <XATable
      :columns="detailColumns"
      :dataSource="detailTableData"
      :loading="detailLoading"
    >
      <template #income="{ record }"> $ {{ record.income }} </template>
    </XATable>
  </XDialog>
</template>

<script lang="ts" setup>
import Vue, {
  onMounted,
  ref,
  watch,
  defineAsyncComponent,
  onBeforeUnmount,
  computed,
} from "vue";
import {
  admDateList,
  configAdmList,
  admDateListAdUnit,
  h5AdmDateList,
  adsDetailList,
  allH5AdmDateList,
} from "@/api/api";
const XATable = defineAsyncComponent(() => import("@/components/XATable.vue"));
import XDialog from "@/components/XDialog.vue";

import { useStore } from "vuex";
const store = useStore();
import dayjs, { Dayjs } from "dayjs";

const props = defineProps<{
  appData: any;
  dateTime: any;
  //   isConsume: boolean;
  isRefresh: boolean;
  dbName: String;
}>();
const currentAppId = ref("");
const rightAppIdVal = ref<any[]>([]);
var appIdList: any[] = [];
const maxTagCount = ref(1);
const checkedValue = ref(true);
interface ConfigItem {
  dbName: string;
  appName: string;
}

const configList = ref<ConfigItem[]>([]);
const dateValue = ref("");
const pageNo = ref(1);
const activeKey = ref(-1);
const detailVisible = ref(false);
const detailLoading = ref(false);
const adsTitle = ref("详情");
const curDetailRow = ref<any>({});

const columns = ref([
  { title: "Date", key: "day", dataIndex: "day" },
  //   { title: "ID", key: "id", dataIndex: "id" },
  //   { title: "Remark", key: "scene", dataIndex: "scene" },
  { title: "*Page View", key: "pageView", dataIndex: "pageView" },
  { title: "*Revenue", key: "income", dataIndex: "income" },
  { title: "Action", key: "action", dataIndex: "action" },
]);
const detailColumns = ref([
  { title: "*Page View", key: "pageView", dataIndex: "pageView" },
  { title: "*Revenue", key: "income", dataIndex: "income" },
  { title: "URL", key: "url", dataIndex: "url" },
]);
const tableData = ref([]);
const detailTableData = ref([]);
const loading = ref(false);
let timerInval = ref();
var BackOrderIds: any[] = [];

const getRequestData = () => {
  // 添加安全检查
  if (
    !dateValue.value ||
    !Array.isArray(dateValue.value) ||
    dateValue.value.length < 2
  ) {
    console.warn("dateValue is not properly set");
    return;
  }

  loading.value = true;
  const params: any = {
    beginTime: dayjs(dateValue.value[0]).format("YYYY-MM-DD"),
    endTime: dayjs(dateValue.value[1]).format("YYYY-MM-DD"),
  };
  if (activeKey.value !== -1) {
    params.dbName = activeKey.value;
  }
  allH5AdmDateList(params)
    .then((res) => {
      loading.value = false;
      //console.log(res.data, "=================");
      tableData.value = res.data || [];
    })
    .catch((error) => {
      loading.value = false;
      console.error("Failed to fetch data:", error);
    });
};
// 监听 Vuex 的 refreshNeeded 状态
const refreshNeeded = computed(() => store.state.refundRefreshNeeded);

// 监控 refreshNeeded 的变化
watch(refreshNeeded, (newValue) => {
  if (newValue) {
    // 执行页面刷新操作
    getRequestData();
    // 重置刷新状态
    store.dispatch("resetRefundRefresh");
  }
});

watch(
  () => props.isRefresh,
  (cur, old) => {
    getRequestData();
  }
);

watch(
  () => props.dateTime,
  (cur, old) => {
    //console.log(cur);
    dateValue.value = cur;
    getRequestData();
  },
  {
    immediate: true,
  }
);

const tabClick = (tabIndex: any) => {
  //console.log(tabIndex);
  if (tabIndex === -1) {
    currentAppId.value = "";
    activeKey.value = -1;
  } else {
    currentAppId.value = tabIndex;
    activeKey.value = tabIndex;
  }
  getRequestData();
};
const pageChange = (page: any) => {
  pageNo.value = page;
  getRequestData();
};
const getConfigList = () => {
  configAdmList({}).then((res) => {
    configList.value = res.data;
  });
};
const confirmDetail = (row: any) => {
  //console.log(row);
  curDetailRow.value = row;
  adsTitle.value = "详情" + "(" + row.day + ")";
  detailVisible.value = true;
  detailLoading.value = true;
  var beginTime = row.date;
  var endTime = row.date;
  if (row.date === "汇总") {
    beginTime = dayjs(dateValue.value[0]).format("YYYY-MM-DD");
    endTime = dayjs(dateValue.value[1]).format("YYYY-MM-DD");
  }
  var params: any = {
    beginTime: row.day,
    endTime: row.day,
  };
  if (activeKey.value !== -1) {
    params.dbName = activeKey.value;
  }

  adsDetailList(params).then((res) => {
    detailLoading.value = false;
    detailTableData.value = res.data;
  });
};
onMounted(() => {
  checkedValue.value = store.state.refundCheckedValue;
  dateValue.value = props.dateTime;
  getConfigList();
  getRequestData();
});
const toFixedDown = (num: any, digits: any) => {
  const factor = Math.pow(10, digits);
  return Math.floor(num * factor) / factor;
};
</script>
<style>
.a-tab-pane-content {
  overflow-x: none !important;
}
</style>
